module.exports = __webpack_public_path__ + "files/b92f2a3353391d8de710db8ad932962d.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-16x16.png
// module id = 538
// module chunks = 76